/*
 * Instant 0s Header Resize Trigger
 * Bypasses the theme debounce timer by firing theme:resize on every frame
 */

(function () {
  let ticking = false;

  function triggerInstantResize() {
    if (!ticking) {
      requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent('theme:resize', { bubbles: true }));
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('resize', triggerInstantResize, { passive: true });
  window.addEventListener('orientationchange', triggerInstantResize, { passive: true });
})();